const deviceType = (userAgent: string) => {
  const knownDevices = {
    mobile: [
      "iPhone;",
      "iPod;",
      "iPod touch;",
      "^HTC",
      "Fennec",
      "IEMobile",
      "BB10;",
      "BlackBerry",
      "SymbianOS.*AppleWebKit",
      "^Mozilla.*Mobile.*Firefox",
      "^Mozilla.*Chrome.*Mobile",
      "Opera Mobi",
      "Android.*Mobile",
      "Android.*Mini",
      "Symbian",
      "^SonyEricsson",
      "^Nokia",
      "^SAMSUNG",
      "^LG",
    ],
    tablet: ["iPad;", "Android"],
  };

  function isDeviceIn(devices: string[]) {
    let regex;
    for (let i = 0; i < devices.length; i += 1) {
      regex = devices[i];
      if (userAgent.match(new RegExp(regex))) {
        return true;
      }
    }
    return false;
  }

  if (userAgent) {
    if (isDeviceIn(knownDevices.mobile)) {
      return "mobile";
    }
    if (isDeviceIn(knownDevices.tablet)) {
      return "tablet";
    }
  }
  return "desktop";
};

const createDeviceDefaults = () => {
  if (typeof window === "undefined") {
    return {};
  }

  const { userAgent } = window.navigator;

  return {
    userAgent,
    deviceType: deviceType(userAgent),
  };
};

const deviceDefaults = createDeviceDefaults();

export { deviceDefaults };
